import styled from 'styled-components';

import { lightGray, textGray, white } from '../../modules/colors';
import { fonts } from '../../modules/metrics';

export const TextareaStyle = styled.textarea`
  background-color: ${white};
  border: 1px solid ${lightGray};
  border-radius: 4px;
  color: ${textGray};
  display: block;
  font-size: ${fonts.md}px;
  padding: 8px;
  resize: none;
  width: 100%;

  ::placeholder {
    color: ${lightGray};
  }

  :disabled {
    opacity: 0.5;
  }
`;
